import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WheelsVehicle, WheelsVehicleType, getWheelsVehicleCapacity } from '../../../domain/wheels';

interface Props {
  vehicles: WheelsVehicleType[];
}

export const WheelsVehiclesCapacity = ({ vehicles }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack flexDirection={{ xs: 'column', sm: 'row' }} justifyContent="space-between" gap={4} mt={4}>
      {vehicles.map((vehicle) => {
        const vehicle_capacity = getWheelsVehicleCapacity(vehicle.id as WheelsVehicle);

        return (
          <Stack gap={2}>
            <img
              src={`/images/wheels/${vehicle.id}.svg`}
              style={{ width: 80, height: 40 }}
              alt={`${vehicle.name} ilustration`}
            />
            <Stack>
              <Typography color="primary.main" fontWeight={700}>{vehicle.name}</Typography>
              <Typography color="#B4B4B7" fontSize={12} fontWeight={400}>
                {t('wheels_service.vehicle_capacity.capacity')}: {vehicle_capacity?.min}{' '}
                {t('wheels_service.vehicle_capacity.to')} {vehicle_capacity?.max}{' '}
                {t('wheels_service.vehicle_capacity.people')}
              </Typography>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
};
